import { RiskIQAccess } from 'types/graphql-global-types';

// Least to most access
export const RISK_IQ_LEVELS: RiskIQAccess[] = [
    RiskIQAccess.NO_ACCESS,
    RiskIQAccess.READ_ONLY_ACCESS,
    RiskIQAccess.READ_ONLY_READ_WRITE_COMMENTS_ACCESS,
    RiskIQAccess.READ_WRITE_ACCESS,
];

export const RISK_IQ_LABEL_KEYS: Record<RiskIQAccess, string> = {
    [RiskIQAccess.NO_ACCESS]: 'admin:trialOsStudyTeam.riskIQAccess.noAccess',
    [RiskIQAccess.READ_ONLY_ACCESS]: 'admin:trialOsStudyTeam.riskIQAccess.readOnlyAccess',
    [RiskIQAccess.READ_ONLY_READ_WRITE_COMMENTS_ACCESS]:
        'admin:trialOsStudyTeam.riskIQAccess.readOnlyReadWriteCommentsAccess',
    [RiskIQAccess.READ_WRITE_ACCESS]: 'admin:trialOsStudyTeam.riskIQAccess.readWriteAccess',
};

export interface AccessColumn {
    key: 'riskIQ';
    headerKey: string;
    levels: RiskIQAccess[];
    labelKey: (level: RiskIQAccess) => string;
}

// One entry per TrialOS app; add an entry here to add a column to the table
export const ACCESS_COLUMNS: AccessColumn[] = [
    {
        key: 'riskIQ',
        headerKey: 'uam:trialOsStudyMembershipDialog.riskIqAccess',
        levels: RISK_IQ_LEVELS,
        labelKey: (level) => RISK_IQ_LABEL_KEYS[level],
    },
];
